import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Custom New Relic Dashboards for Backend and Frontend Monitoring",
  "description": "Guide to setting up customized New Relic dashboards for comprehensive backend and frontend performance monitoring."
};
export let structuredData = {
  "contents": [{
    "heading": "key-visualizations-needed",
    "content": "Application Performance"
  }, {
    "heading": "key-visualizations-needed",
    "content": "Response Time"
  }, {
    "heading": "key-visualizations-needed",
    "content": "Throughput"
  }, {
    "heading": "key-visualizations-needed",
    "content": "Error Rate"
  }, {
    "heading": "key-visualizations-needed",
    "content": "Resource Utilization"
  }, {
    "heading": "key-visualizations-needed",
    "content": "CPU Usage"
  }, {
    "heading": "key-visualizations-needed",
    "content": "Memory Usage"
  }, {
    "heading": "key-visualizations-needed",
    "content": "Disk I/O"
  }, {
    "heading": "key-visualizations-needed",
    "content": "Database Performance"
  }, {
    "heading": "key-visualizations-needed",
    "content": "Query Execution Time"
  }, {
    "heading": "key-visualizations-needed",
    "content": "Connection Pooling"
  }, {
    "heading": "key-visualizations-needed",
    "content": "Cache Hit Ratio"
  }, {
    "heading": "key-visualizations-needed",
    "content": "External Services"
  }, {
    "heading": "key-visualizations-needed",
    "content": "API Call Latency"
  }, {
    "heading": "key-visualizations-needed",
    "content": "Error Rates in External Calls"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "Page Load Performance"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "First Paint & First Contentful Paint"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "Time to Interactive"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "Page Load Time"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "User Interactions"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "First Input Delay (FID)"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "Interaction Timing"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "JavaScript Errors"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "Error Frequency"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "Error Impact Analysis"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "Geographical Performance"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "Load Times by Region"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "Browser and Device Performance"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "Performance by Browser"
  }, {
    "heading": "key-components-and-visualizations",
    "content": "Device Type Analysis"
  }],
  "headings": [{
    "id": "backend-monitoring-dashboard",
    "content": "Backend Monitoring Dashboard"
  }, {
    "id": "key-visualizations-needed",
    "content": "Key Visualizations Needed"
  }, {
    "id": "frontend-monitoring-dashboard",
    "content": "Frontend Monitoring Dashboard"
  }, {
    "id": "key-components-and-visualizations",
    "content": "Key Components and Visualizations"
  }]
};
export const toc = [{
  depth: 2,
  url: "#backend-monitoring-dashboard",
  title: _jsx(_Fragment, {
    children: "Backend Monitoring Dashboard"
  })
}, {
  depth: 3,
  url: "#key-visualizations-needed",
  title: _jsx(_Fragment, {
    children: "Key Visualizations Needed"
  })
}, {
  depth: 2,
  url: "#frontend-monitoring-dashboard",
  title: _jsx(_Fragment, {
    children: "Frontend Monitoring Dashboard"
  })
}, {
  depth: 3,
  url: "#key-components-and-visualizations",
  title: _jsx(_Fragment, {
    children: "Key Components and Visualizations"
  })
}];
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    h3: "h3",
    li: "li",
    ol: "ol",
    p: "p",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "backend-monitoring-dashboard",
      children: "Backend Monitoring Dashboard"
    }), "\n", _jsx(_components.h3, {
      id: "key-visualizations-needed",
      children: "Key Visualizations Needed"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Application Performance"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Response Time"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Throughput"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Error Rate"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Resource Utilization"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "CPU Usage"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Memory Usage"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Disk I/O"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Database Performance"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Query Execution Time"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Connection Pooling"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Cache Hit Ratio"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "External Services"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "API Call Latency"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Error Rates in External Calls"
            })
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "frontend-monitoring-dashboard",
      children: "Frontend Monitoring Dashboard"
    }), "\n", _jsx(_components.h3, {
      id: "key-components-and-visualizations",
      children: "Key Components and Visualizations"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Page Load Performance"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "First Paint & First Contentful Paint"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Time to Interactive"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Page Load Time"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "User Interactions"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "First Input Delay (FID)"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Interaction Timing"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "JavaScript Errors"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Error Frequency"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Error Impact Analysis"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Geographical Performance"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Load Times by Region"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Browser and Device Performance"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Performance by Browser"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.strong, {
              children: "Device Type Analysis"
            })
          }), "\n"]
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
